import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'

import { MultiSelectFilter } from '../MultiSelectFilter'

export const MultiSelectTransactionTypeFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const transactionTypes = useAppSelector((state) => state.transactions.types)
  const data = transactionTypes.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <MultiSelectFilter
      placeholder='TransactionTypes'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
    />
  )
}
